<template>
    <v-card class="day-result-card px-4 text-primary"
            variant="outlined">
        <div v-if="showText">
            <v-card-title>Итог дня</v-card-title>
            <v-card-text>
                <v-textarea label="Итог дня"
                            class="mt-5 mt-sm-5 mt-md-0"
                            auto-grow
                            rows="1"
                            v-model="dayResult"></v-textarea>

                <SmilesRadioButtons v-if="showRating"
                                    v-model="dayRating" />
            </v-card-text>
        </div>
        <div v-else>
            <v-card-title class="d-flex flex-row px-0">
                Итог дня: <SmilesRadioButtons v-model="dayRating" />
            </v-card-title>
        </div>
    </v-card>
</template>

<script>
    import SmilesRadioButtons from "@/components/client/day_results/SmilesRadioButtons.vue";

    import _debounce from "lodash/debounce";

    export default {
        props: {
            modelValue: Object,
            showText: Boolean,
            showRating: Boolean
        },

        components: {
            SmilesRadioButtons
        },

        emits: ["update:modelValue"],

        data() {
            return {
                dayResult: this.modelValue?.result,
                dayRating: this.modelValue?.rating
            };
        },

        computed: {
            newModelValue() {
                return {
                    date: this.modelValue.date,
                    result: this.dayResult,
                    rating: this.dayRating
                };
            }
        },

        watch: {
            newModelValue(newValue) {
                if (newValue.result == (this.modelValue?.result)
                    && newValue.rating == (this.modelValue?.rating)) {
                    return;
                }

                this.updateModelValue(newValue);
            }
        },

        methods: {
            updateModelValue: _debounce(
                function (value) {
                    this.$emit("update:modelValue", value);
                },
                1000)
        }
    };
</script>

<style lang="scss">
    .day-result-card {
    }
</style>